import { render, staticRenderFns } from "./brandInfoProductDetailDialog.vue?vue&type=template&id=7836dd84&scoped=true"
import script from "./brandInfoProductDetailDialog.vue?vue&type=script&lang=js"
export * from "./brandInfoProductDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./brandInfoProductDetailDialog.vue?vue&type=style&index=0&id=7836dd84&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7836dd84",
  null
  
)

export default component.exports